// Third-party Imports
import styled from '@emotion/styled'

// Config Imports
import themeConfig from '@configs/themeConfig'

// Util Imports
import { commonLayoutClasses } from '@layouts/utils/layoutClasses'

type StyledMainProps = {
  isContentCompact: boolean
}

const StyledMain = styled.main<StyledMainProps>`
  padding: ${themeConfig.layoutPadding}px;
  padding-bottom: calc(${themeConfig.layoutPadding}px + var(--mobile-bottom-nav-height, 0px));
  ${({ isContentCompact }) =>
    isContentCompact &&
    `
    margin-inline: auto;
    max-inline-size: ${themeConfig.compactContentWidth}px;
  `}

  &:has(.${commonLayoutClasses.contentHeightFixed}) {
    display: flex;
    overflow: hidden;
  }

  &:has(.gia-it-full-width) {
    margin-inline: 0;
    max-inline-size: none;
    inline-size: 100%;
  }

  &:has(.gia-it-full-width) .gia-it-full-width {
    min-block-size: calc(100vh - (${themeConfig.layoutPadding}px * 2));
  }

  @media (max-width: 600px) {
    padding: 16px;
    padding-bottom: calc(16px + var(--mobile-bottom-nav-height, 0px));
  }
`

export default StyledMain
